import React from 'react';
import styled, { css } from 'styled-components';
import useTranslation from 'hooks/use-translation';
import { FooterContainer } from 'src/payments/components';
import { useObserver } from 'mobx-react-lite';
import useDutchiePayEnrollment from 'hooks/use-dutchiePay-enrollment';
import { PBB_NAME } from 'src/payments/constants';

export function CommonFooterLayout({ className }: { className?: string }): JSX.Element | null {
  const { t, Trans } = useTranslation();
  const DutchiePayEnrollment = useDutchiePayEnrollment();
  const dispensaryName = useObserver(() => DutchiePayEnrollment.dispensary.name);
  const brandedDutchiePayName = useObserver(() => DutchiePayEnrollment.dispensary.brandedDutchiePayName);
  const isCobrandedSignup = useObserver(() => DutchiePayEnrollment.isCobrandedSignup);

  const payByBank = t('pbb.footer.payByBank', PBB_NAME);
  const footerText = (
    <Trans i18nKey='pbb.footer'>
      is the simple and secure way to purchase products from{' '}
      {(isCobrandedSignup && dispensaryName) || `your favorite dispensary.`}
    </Trans>
  );
  return (
    <FooterContent className={className}>
      <Bold>{brandedDutchiePayName || payByBank}</Bold>
      {footerText}
    </FooterContent>
  );
}

const Bold = styled.b<{ brandedDutchiePayName?: string }>`
  ${({ theme: { colors }, brandedDutchiePayName }) => css`
    color: ${brandedDutchiePayName ? colors.dutchiePayGreen : colors.grey[10]};

    &:after {
      content: ' ';
    }
  `}
`;

const FooterContent = styled(FooterContainer)`
  ${({ theme: { colors } }) => css`
    color: ${colors.grey[50]};
    margin: 24px auto 0 auto;
    padding: 0 20px;
  `}
`;
